import { Collapse, Radio } from "@mui/material";
import CrossIcon from "assets/icons/CrossIcon";
import PercentIcon from "assets/icons/PercentIcon";
import PlusIcon from "assets/icons/PlusIcon";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import { useFormikContext } from "formik";
import { formatPrice } from "helpers";
import useCurrency from "helpers/useCurrency";
import { useEffect, useState } from "react";

export default function ProfitCalculation() {
  const data = useFormikContext<InstallmentData>();
  const { defCur } = useCurrency();
  const currency = data.values.currency?.en_title || defCur.en_title;

  const profitTypes = [
    { label: "سود کلی (درصد)", abbr: ["c", "s"], inputType: "percent", name: "total", formula: f1 },
    // { label: "سود مستقیم", abbr: ["c", "c"], inputType: "percent", name: "direct", formula: f2 },
    { label: "سود توافقی (مبلغ)", abbr: ["p", "c"], inputType: "currency", name: "manual", formula: f3 },
  ];
  const profitType = profitTypes.findIndex((x) => x.name === data.values.profitType);
  const [active, setActive] = useState(profitType > -1 ? profitType : 0);

  const symbols: any = {
    c: <CrossIcon color="#6B7888" bgColor="transparent" scale={0.7} />,
    p: <PlusIcon color="#6B7888" scale={0.5} />,
    s: <span>/</span>,
  };

  function f1(rate: number) {
    const { totalPrice, installmentsCount, prePay, prePayType } = data.values;

    if (!totalPrice || !installmentsCount) return;
    const _prePay = prePayType === "currency" ? prePay || 0 : totalPrice * ((prePay || 0) / 100);
    const newTotal = totalPrice - _prePay;

    return newTotal * (rate / 100);
  }

  function f2(rate: number) {
    const { totalPrice, installmentsCount } = data.values;
    if (!totalPrice || !installmentsCount) return;
    return totalPrice * rate * installmentsCount;
  }

  function f3(rate: number) {
    const { totalPrice, installmentsCount } = data.values;
    if (!totalPrice || !installmentsCount) return;

    return rate;
  }

  useEffect(() => {
    if (data.values.totalPrice && data.values.profitType !== "manual") {
      if (data.values.profitType === "total") {
        data.values.profitRate && data.setFieldValue("totalProfit", f1(data.values.profitRate));
      } else if (data.values.profitType === "direct") {
        data.values.profitRate && data.setFieldValue("totalProfit", f2(data.values.profitRate));
      }
    }

    return () => {};
  }, [data.values.totalPrice]);

  return (
    <div>
      {profitTypes.map((item, i) => {
        return (
          <div
            key={i}
            className={`flex flex-col w-full gap-4 p-4 rounded-md ${active === i && "bg-slate-100"}`}
          >
            <div
              className="flex items-center gap-3 cursor-pointer w-fit"
              onClick={() => {
                setActive(i);
                data.setFieldValue("profitRateType", item.inputType);
                data.setFieldValue("profitType", item.name);
                if (active !== i) {
                  data.setFieldValue("totalProfit", 0);
                  data.setFieldValue("profitRate", 0);
                }
              }}
            >
              <Radio checked={active === i} />
              <div className="flex items-center h-10 gap-8">
                <span className="font-bold">{item.label}</span>
                {/*<div className="flex items-center gap-2 text-[#6B7888]">*/}
                {/*  <span>مبلغ کل</span>*/}
                {/*  {symbols[item.abbr[0]]}*/}
                {/*  <span>نرخ سود</span>*/}
                {/*{symbols[item.abbr[1]]}*/}
                {/*<span>تعداد اقساط</span>*/}
                {/*</div>*/}
              </div>
            </div>
            <Collapse in={active === i}>
              <div className="flex flex-wrap items-center justify-between w-full gap-4 md:px-14">
                <div className="flex items-center gap-4">
                  <span className="min-w-[100px]">
                    نرخ {item.inputType === "percent" ? "(درصد)" : `(${currency})`}
                  </span>
                  <BasicTextInput
                    type={item.inputType === "percent" ? "number-native" : "price"}
                    prefix={
                      item.inputType === "percent" ? (
                        <PercentIcon color="#6B7888" style={{ transform: "scale(0.7)" }} />
                      ) : (
                        <span className="text-[#6B7888]">{currency}</span>
                      )
                    }
                    onChange={(val) => {
                      if (typeof val === "number") data.setFieldValue("totalProfit", item.formula(val));
                      data.setFieldValue("profitRate", val);
                    }}
                    val={data.values.profitRate}
                  />
                </div>
                <div className="flex items-center gap-2">
                  <span>مبلغ کل سود:</span>
                  <span>{formatPrice(data.values.totalProfit || 0)}</span>
                  <span className="text-dark-3">{currency}</span>
                </div>
              </div>
            </Collapse>
          </div>
        );
      })}
    </div>
  );
}
